<template>
  <BreadCrumb page="Beranda > Pendaftaran > Data Keputusan > Lihat Data Keputusan > Pelunasan"></BreadCrumb>
  <div class="container content-area">
    <div class="row">
      <div class="col-md-10">
        <h3 class="judul-seksi-sga">Keputusan PSB diterima untuk {{ data.nama_anak }} No Formulir
          {{ data.no_formulir }} </h3>
      </div>
      <div class="col-md-2 text-right my-auto">
        <a href="#" @click="toggleview" class="btn btn-sm btn-light"><i class="fa-solid fa-caret-left"></i></a>
      </div>
      <div class="col-12">
        <hr>
      </div>
    </div>
    <div class="notes-notification-sga">
      <p><strong>Catatan :</strong><br></p>
      <ul>
        <li>Jika ingin menambahkan attachment, maka pilih file attachment terlebih dahulu sebelum klik tombol tindakan</li>
        <li>Isi alamat email test untuk kirim email test ke alamat tersebut</li>
        <li>Pilih Jenis Diskon</li>
        <li>Jika Jenis Diskon Khusus, silakan masukan nominal uang diskonnya</li>
        <li>Proses update diskon dan penerbitan nomor surat oleh sistem, dilakukan ketika pengguna menekan tombol lihat surel pelunasan</li>
      </ul>
      <p></p>
    </div>
    <div class="form-general">
      <div class="row">
        <div class="col-md-4">
          <div class="row">
            <div class="col-12 spacer-field-sga">
              <normal-label>No formulir</normal-label>
              <br/>
              <normal-label2>{{ data.no_formulir }}</normal-label2>
            </div>
            <div class="col-12 spacer-field-sga">
              <normal-label>Nama Ananda</normal-label>
              <br/>
              <normal-label2>{{ data.nama_anak }}</normal-label2>
            </div>
            <div class="col-12 spacer-field-sga">
              <normal-label>Nama Orang Tua</normal-label>
              <ul>
                <li>
                  <normal-label2>{{ data.nama_ayah }}</normal-label2>
                </li>
                <li>
                  <normal-label2>{{ data.nama_ibu }}</normal-label2>
                </li>
                <li v-if="data.nama_ayah_tiri">{{ data.nama_ayah_tiri }}</li>
                <li v-if="data.nama_ibu_tiri">{{ data.nama_ibu_tiri }}</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-8">
          <h4 style="color: darkorange;">Tagihan Uang Pelunasan</h4>
          <ToggleSwitch v-model="logpelunasan" />
          <div class="row">
            <div class="col-12" v-show="logpelunasan">
              <div class="table-responsive">
                <table class="table table-striped ">
                  <thead>
                  <tr>
                    <th scope="col">Status </th>
                    <th scope="col">Tanggal pengiriman</th>
                    <th scope="col">Info</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(srt,idx) in dataLogSurat" :key="idx">
                    <td>{{srt.log_type}}</td>
                    <td>{{srt.log_date}}</td>
                    <td>{{srt.log_desc}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <hr>
          <label>Status diskon</label>
          <select v-model="diskon.stsdiskon" class="w-100 form-control" required="">
            <option value="normal">Normal</option>
            <option value="diskon">Ada diskon</option>
          </select>
          <select
              v-model="diskon.jenisdiskon"
              v-show="diskon.stsdiskon==='diskon'"
              class="w-100 form-control"
              required
              style="margin-top: 10px;"
          >
            <option value="">Pilih Diskon</option>
            <option
                v-for="(item, key) in datadiskon"
                :key="key"
                :value="key"
            >
              {{ item.text }}
            </option>
          </select>
          <keterangan-form>{{infodiskon}}</keterangan-form>
          <div class="row" v-if="showdiskonkhusus">
            <div class="col-md-6 spacer-field-sga">
              <div class="datepicker date input-group">
                <InputNumber
                    v-model="diskon.khusus.uangpengembangan"
                    @update:modelValue="kalkulatediskonkhusus"
                    class="w-100 form-control" inputId="currency-indonesia"
                    mode="currency" currency="IDR"
                    currencyDisplay="symbol"
                    :minFractionDigits="0"
                    :maxFractionDigits="0"
                    locale="en-ID" fluid />
              </div>
              <keterangan-form>Masukkan pengurangan uang pengembangan dalam rupiah</keterangan-form></div>
            <div class="col-md-6 spacer-field-sga">
              <div class="datepicker date input-group">
                <InputNumber
                    v-model="diskon.khusus.uangsekolah"
                    @update:modelValue="kalkulatediskonkhusus"
                    class="w-100 form-control" inputId="currency-indonesia"
                    mode="currency" currency="IDR"
                    currencyDisplay="symbol"
                    :minFractionDigits="0"
                    :maxFractionDigits="0"
                    locale="en-ID" fluid />
              </div>
              <keterangan-form>Masukkan pengurangan uang sekolah dalam rupiah</keterangan-form></div>
          </div>
          <div class="row">
            <div class="col-md-12 spacer-field-sga">
              <label>Biaya SPP: </label>
              <div class="flex flex-wrap gap-4" v-if="biayatahunan?.spp">
                <div class="flex items-center gap-2" v-for="(item,idx) in biayatahunan.spp" :key="idx">
                  <RadioButton class="mr-1 mb-1" v-model="biaya.spptipe" :value="idx" @click="getNilaiSPP" @change="getNilaiSPP"/>
                  <normal-label>{{item.info}}</normal-label>
                </div>
              </div>
            </div>
            <div class="col-md-12 spacer-field-sga">
              <label>Biaya Uang Pembangunan: </label>
              <div class="flex flex-wrap gap-4" v-if="biayatahunan?.up">
                <div class="flex items-center gap-2" v-for="(item,idx) in biayatahunan.up" :key="idx">
                  <RadioButton class="mr-1 mb-1" v-model="biaya.uptipe" :value="idx" @click="getNilaiUP" @change="getNilaiUP" />
                  <normal-label>{{item.info}}</normal-label>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12" style="margin-top: 25px;">
              <table class="table table-striped ">
                <thead>
                <tr>
                  <th colspan="4" class="text-center text-uppercase bg-light" scope="col">Rincian Biaya</th>
                </tr>
                </thead>
                <tbody>
                  <tr class="bg-simulasi-kewajiban">
                    <td>Uang Pengembangan</td>
                    <td>:</td>
                    <td></td>
                    <td><InputNumber v-model="biaya.up"/></td>
                  </tr>
                  <tr class="bg-simulasi-kewajiban">
                    <td>Uang Sekolah</td>
                    <td>:</td>
                    <td></td>
                    <td><InputNumber v-model="biaya.spp"/></td>
                  </tr>
                  <tr class="bg-simulasi-kewajiban">
                    <td colspan="3" class="font-weight-bold">(i) Total Kewajiban</td>
                    <td>Rp. {{kewajibanTotal}}</td>
                  </tr>
                  <tr>
                    <td colspan="4" class="bg-simulasi-potongan space-tr font-weight-bold">Potongan untuk siswa:</td>
                  </tr>
                  <tr class="bg-simulasi-potongan">
                    <td>Uang Pengembangan (tahun pertama)</td>
                    <td>:</td>
                    <td></td>
                    <td><InputNumber v-model="biaya.diskon.diskonuptahunpertama"/></td>
                  </tr>
                  <tr class="bg-simulasi-potongan">
                    <td>Uang Sekolah (pembayaran 1 tahun)</td>
                    <td>:</td>
                    <td></td>
                    <td><InputNumber v-model="biaya.diskon.diskonspppembayaran1tahun"/></td>
                  </tr>
                  <tr class="bg-simulasi-potongan">
                    <td>Uang Sekolah</td>
                    <td>:</td>
                    <td></td>
                    <td><InputNumber v-model="biaya.diskon.diskonspp"/></td>
                  </tr>
                  <tr class="bg-simulasi-potongan">
                    <td colspan="3" class="font-weight-bold">(ii) Total Potongan</td>
                    <td>Rp. {{potonganTotal}}</td>
                  </tr>
                  <tr class="bg-simulasi-total-dibayar space-tr">
                    <td colspan="3" class="font-weight-bold">Total yang harus dibayarkan ( i- ii )</td>
                    <td class="font-weight-bold">Rp. {{totaldibayarkan}}</td>
                  </tr>
                  <tr class="bg-simulasi-tanda-konfirmasi space-tr">
                    <td colspan="3" class="font-weight-bold">Tanda Konfirmasi yang telah dibayarkan</td>
                    <td class="font-weight-bold">Rp. {{tandaKonfirmasi}}</td>
                  </tr>
                  <tr class="bg-simulasi-jumlah-harus-dibayarkan space-tr">
                    <td colspan="3" class="font-weight-bold">Jumlah kewajiban yang harus dibayarkan</td>
                    <td class="font-weight-bold">Rp. {{totalyangharusdibayarkan}}</td>
                  </tr>
                  <tr>
                    <td colspan="4" class="text-center">
                      <LoadSpinner v-if="sedangsimpansuratpelunasan"></LoadSpinner>
                      <button v-show="!sedangsimpansuratpelunasan" @click="simpanbiayapelunasan" class="btn btn-sm btn-success mr-1">Simpan</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row">
            <div class="col-12" style="margin-top: 25px;">
              <table class="table table-striped ">
                <thead>
                <tr>
                  <th scope="col">Status diskon</th>
                  <th scope="col">Tindakan</th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>Email orang tua</td>
                  <td colspan="3">
                    <div v-for="(email,key,idx) of data.email" v-show="email!=null" :key="idx" class="flex items-center gap-2 mb-2">
                      <Checkbox v-model="emailortu" :inputId="email" name="category" :value="email" class="mr-2" />
                      ({{key}}) {{ email }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Email test</td>
                  <td colspan="3">
                    <input type="email" class="form-control" v-model="emailtest">
                    <keterangan-form>Untuk kirim ke beberapa email, gunakan pemisah dengan tanda ; (titik koma)</keterangan-form>
                  </td>
                </tr>
                <tr>
                  <td>Nomor Surat</td>
                  <td colspan="3">
                    <input type="email" class="form-control" v-model="nomorsuratpelunasan">
                    <keterangan-form>Masukan nomor surat, jika kosong sistem akan generate nomor</keterangan-form>
                  </td>
                </tr>
                <tr>
                  <td>{{diskon.display}}</td>
                  <td>
                    <LoadSpinner v-if="sedangkirimsuratpelunasan"></LoadSpinner>
                    <button v-show="!sedangkirimsuratpelunasan" @click="lihatsuratpelunasan" class="btn btn-sm btn-success mr-1">Lihat surel pelunasan</button>
                    <button v-show="!sedangkirimsuratpelunasan" @click="kirimsuratpelunasan('test')" class="btn btn-sm btn-success mr-1">Test surel pelunasan</button>
                    <button v-show="!sedangkirimsuratpelunasan" @click="kirimsuratpelunasan('kirim')" class="btn btn-sm btn-success mt-1">Kirim surel pelunasan</button>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-md-11" v-if="messagetrx">
            <AlertSuccess v-if="successtrx" :message="message"></AlertSuccess>
            <AlertDanger v-else :message="message"></AlertDanger>
          </div>
          <h4 style="color: darkorange; margin-top: 15px;">Status Uang Pelunasan</h4>
          <ToggleSwitch v-model="logkwitansi" />
          <div class="row">
            <div class="col-12">
              <div class="table-responsive">
                <table class="table table-striped ">
                  <thead>
                  <tr>
                    <th scope="col">Status pelunasan </th>
                    <th scope="col">Tindakan</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>Status</td>
                    <td>{{pelunasan.display}}</td>
                  </tr>
                  <tr>
                    <td>Nomor Surat Kuitansi</td>
                    <td>
                      <input type="text" class="form-control" v-model="nomorsuratkwitansi" placeholder="contoh: 100/SGA/XXX/XXX">
                      <keterangan-form>Masukan nomor surat lengkap, jika kosong sistem akan generate nomor</keterangan-form>
                    </td>
                  </tr>
                  <tr>
                    <td>Tanggal Surat Kuitansi</td>
                    <td>
                      <input type="text" class="form-control" v-model="tanggalsuratkwitansi" placeholder="contoh: 12/01/2025">
                      <keterangan-form>Masukan tanggal kuitansi, jika kosong sistem akan generate tanggal</keterangan-form>
                    </td>
                  </tr>
                  <tr>
                    <td>Catatan</td>
                    <td><textarea rows="5" cols="50" v-model="pelunasan.catatan"></textarea></td>
                  </tr>
                  <tr>
                    <td>Perubahan</td>
                    <td>
                      <select v-model="pelunasan.status" class="w-100 form-control" required="" style="margin-bottom: 10px;">
                        <option value="belum-dibayar">Belum dibayar</option>
                        <option value="lunas">Lunas</option>
                      </select>
                      <LoadSpinner v-if="sedangupdatepelunasan"></LoadSpinner>
                      <button v-show="!sedangupdatepelunasan" @click="updatepelunasan" class="btn btn-sm btn-success">Ubah status</button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-12" v-show="logkwitansi">
                  <div class="table-responsive">
                    <table class="table table-striped ">
                      <thead>
                      <tr>
                        <th scope="col">Status </th>
                        <th scope="col">Tanggal pengiriman</th>
                        <th scope="col">Info</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(srt,idx) in dataLogKwitansi" :key="idx">
                        <td>{{srt.log_type}}</td>
                        <td>{{srt.log_date}}</td>
                        <td>{{srt.log_desc}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-striped ">
                  <thead>
                  <tr>
                    <th scope="col">Status kuitansi </th>
                    <th scope="col">Tindakan</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>{{diskon.display}}</td>
                    <td>
                      <LoadSpinner v-if="sedangkirimsuratkwitansi"></LoadSpinner>
                      <button v-show="!sedangkirimsuratkwitansi" @click="lihatskwitansi" class="btn btn-sm btn-success mr-1">Simpan & Lihat surel kuitansi</button>
                      <button v-show="!sedangkirimsuratkwitansi" @click="kirimkwitansi('test')" class="btn btn-sm btn-success mr-1">Test surel kuitansi</button>
                      <button v-show="!sedangkirimsuratkwitansi" @click="kirimkwitansi('test')" class="btn btn-sm btn-success mt-1">Kirim surel kuitansi</button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Dialog v-model:visible="visible" maximizable modal :header="header" :style="{ width: '50rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
    <div v-html="content"></div>
  </Dialog>
</template>

<script>
import ToggleSwitch from 'primevue/toggleswitch';
import BreadCrumb from "@/components/BreadCrumb";
import DashboardServices from "@/services/dashboard.services";
import useValidate from "@vuelidate/core/dist/index";
import InputNumber from 'primevue/inputnumber';
import Dialog from 'primevue/dialog';
import LoadSpinner from "@/components/LoadSpinner";
import Checkbox from 'primevue/checkbox';
import AlertDanger from "@/components/AlertDanger";
import AlertSuccess from "@/components/AlertSuccess";
import RadioButton from 'primevue/radiobutton';
export default {
  name: "PageViewPSBditerimaPelunasan",
  components: {BreadCrumb,InputNumber,Dialog,LoadSpinner,Checkbox,AlertDanger,AlertSuccess,ToggleSwitch,RadioButton},
  props: {
    data: undefined
  },
  emits: ['change-view'],
  data: () => ({
    v$: useValidate(),
    loading: false,
    logpelunasan: false,
    logkwitansi: false,
    sedangkirimsuratkeputusan: false,
    sedangsimpansuratpelunasan: false,
    skterkirim: false,
    pelunasanterkirim: false,
    sedangkirimsuratpelunasan: false,
    sedangkirimsuratkwitansi:false,
    sedangupdatepelunasan: false,
    response: '',
    message: '',
    success: false,
    dataKeputusan: [],
    visible: false,
    content:"",
    header:"",
    isupload: false,
    successtrx: false,
    uploadprogress:0,
    uploadLabel: 'Pilih',
    classupload:'',
    showupload: Boolean,
    urlupload:"",
    urldownload:"",
    fileattachment:"",
    dataSurat:[],
    dataKwitansi:[],
    attachmentada: false,
    successloadfile: false,
    linkdokumen:"",
    messagetrx:"",
    emailtest:"",
    filelist:[],
    emailortu:[],
    nomorsuratpelunasan:"",
    nomorsuratkwitansi:"",
    tanggalsuratkwitansi:"",
    diskon:{
      display:"",
      stsdiskon:"",
      jenisdiskon:"",
      khusus:{
        uangpengembangan:0,
        uangsekolah:0,
      }
    },
    pelunasan:{
      display:"",
      status:0,
      catatan:"",
      biaya:0
    },
    biaya:{
      spp:0,
      spptipe:"",
      up:0,
      uptipe:"",
      kewajiban:0,
      uangkonfirmasi:0,
      totaldibayarkan:0,
      diskon:{
        diskonuptahunpertama:0,
        diskonspppembayaran1tahun:0,
        diskonspp:0
      },
    },
    dataanak:[],
    datadiskon:[],
    databiaya:[],
    biayatahunan:[],
    dataLogKwitansi:[],
    dataLogSurat:[],
    loadingdiskon: true
  }),
  computed:{
    showdiskonkhusus(){
      if(this.diskon.stsdiskon==='diskon' && this.diskon.jenisdiskon==='khusus'){
        return true;
      }else{
        return false
      }
    },
    kewajibanTotal() {
      const total = (Number(this.biaya.spp) || 0) + (Number(this.biaya.up) || 0)
      return total.toLocaleString('id-ID')
    },
    tandaKonfirmasi() {
      const total = (Number(this.biaya.uangkonfirmasi) || 0)
      return total.toLocaleString('id-ID')
    },
    potonganTotal() {
      const total = (Number(this.biaya.diskon.diskonuptahunpertama) || 0) + (Number(this.biaya.diskon.diskonspppembayaran1tahun) || 0) + (Number(this.biaya.diskon.diskonspp) || 0)
      return total.toLocaleString('id-ID')
    },
    totaldibayarkan(){
      const kewajiban = (Number(this.biaya.spp) || 0) + (Number(this.biaya.up) || 0)
      const potongan = (Number(this.biaya.diskon.diskonuptahunpertama) || 0) + (Number(this.biaya.diskon.diskonspppembayaran1tahun) || 0) + (Number(this.biaya.diskon.diskonspp) || 0)
      const totalbiaya = kewajiban - potongan
      return totalbiaya.toLocaleString('id-ID')
    },
    totalyangharusdibayarkan(){
      const kewajiban = (Number(this.biaya.spp) || 0) + (Number(this.biaya.up) || 0)
      const potongan = (Number(this.biaya.diskon.diskonuptahunpertama) || 0) + (Number(this.biaya.diskon.diskonspppembayaran1tahun) || 0) + (Number(this.biaya.diskon.diskonspp) || 0)
      const totalbiaya = kewajiban - potongan
      const uangkonfirmasi = (Number(this.biaya.uangkonfirmasi) || 0)
      const totalharusdibayarkan = totalbiaya - uangkonfirmasi;
      return totalharusdibayarkan.toLocaleString('id-ID')
    },
    infodiskon(){
      if(!this.loadingdiskon){
        this.showbiaya()
        if(this.diskon.stsdiskon==='diskon'){
          if(this.diskon.jenisdiskon==='kartap'){
            return 'Diskon Uang Sekolah : '+this.datadiskon?.kartap?.info
          }else if(this.diskon.jenisdiskon==='sibling'){
            return 'Diskon Uang Sekolah : '+this.datadiskon?.sibling?.info
          }else if(this.diskon.jenisdiskon==='paruhwaktu'){
            return 'Diskon Uang Sekolah : '+this.datadiskon?.paruhwaktu?.info
          }else{
            return "-";
          }
        }else{
          if(this.diskon.stsdiskon==='normal'){
            return 'Data Biaya : '+this.datadiskon.harga.info
          }else{
            return "-";
          }
        }
      }else{
        return "";
      }
    }
  },
  methods: {
    kalkulatediskonkhusus(){
      this.biaya.diskon.diskonspp = this.diskon.khusus.uangsekolah?? 0
      this.biaya.diskon.diskonuptahunpertama = this.diskon.khusus.uangpengembangan?? 0
    },
    getNilaiSPP(){
      this.$nextTick(() => {
        this.biaya.spp = this.biayatahunan?.spp?.[this.biaya.spptipe]?.value ?? 0
      })
    },
    getNilaiUP(){
      this.$nextTick(() => {
        this.biaya.up = this.biayatahunan?.up?.[this.biaya.uptipe]?.value ?? 0
      })
    },
    hitungBiayaTotal(){
      const kewajiban = (Number(this.biaya.spp) || 0) + (Number(this.biaya.up) || 0)
      const potongan = (Number(this.biaya.diskon.diskonuptahunpertama) || 0) + (Number(this.biaya.diskon.diskonspppembayaran1tahun) || 0) + (Number(this.biaya.diskon.diskonspp) || 0)
      const biayakonfirmasi = (Number(this.biaya.uangkonfirmasi) || 0)
      const yangharusdibayarkan  = kewajiban - potongan;
      const kewajibantotal = yangharusdibayarkan - biayakonfirmasi;
      this.biaya.totaldibayarkan = kewajibantotal;
    },
    showbiaya(){
      if(this.diskon.stsdiskon==='normal'){
        this.biayatahunan = this.databiaya.reguler
        this.biaya.diskon.diskonuptahunpertama = 0;
        this.biaya.diskon.diskonspppembayaran1tahun = 0;
        this.biaya.diskon.diskonspp = 0;
        //this.biayatahunan = this.databiaya.reguler
      }else if(this.diskon.stsdiskon==='diskon' && this.diskon.jenisdiskon==='sibling'){
        this.biayatahunan = this.databiaya.sibling
      }
    },
    toggleview() {
      this.$emit('change-view', true)
    },
    onProgress(event){
      this.isupload = true;
      this.uploadprogress = event.progress;
    },
    beforeUpload(request){
      let user = JSON.parse(localStorage.getItem('usergemala'));
      request.xhr.setRequestHeader('Authorization', 'Bearer ' + user.token);
      request.formData.append('paramname','suratsk');
      request.formData.append('invid',this.data.invid);
      return request;
    },
    onUpload(event){
      let response = event.xhr.response;
      const obj = JSON.parse(response);
      let message = obj.message;
      if(obj.code===1){
        this.fileattachment = obj.data.fileid;
        this.classupload='bg-success';
        this.$toast.add({ severity: 'success', summary: message, detail: 'File Uploaded', life: 3000 });
      }else{
        this.classupload='bg-danger';
        this.$toast.add({ severity: 'danger', summary: message, detail: 'File Uploaded', life: 3000 });
      }
      this.isupload = false;
      this.attachmentada = true;
      this.getDataUploadedFile();
    },
    onSelect(event){
      if(event.files.length >0){
        //this.uploadLabel3 = event.files[0].name;
      }
      this.fileattachment = '';
    },
    lihatskwitansi(){
      this.loading = true;
      this.$store.commit('loading', this.loading);
      let data = {
        'idanak': this.data.idanak,
        'invid': this.data.invid,
        'jenis': 'kwitansi',
        'diskon':this.diskon,
        'nosurat':this.nomorsuratkwitansi,
        'tanggalsurat': this.tanggalsuratkwitansi,
        'attachment': this.fileattachment,
        'biaya': this.biaya
      };
      this.sedangkirimsuratkwitansi = true;
      this.content = "";
      let path = '/dashboard/lihatkwitansi';
      DashboardServices.postData(data, path).then(
          (response) => {
            this.response = response.data;
            this.message = response.data.message;
            if (response.data.status === 200) {
              this.success = true;
              this.content = atob(this.response.data);
              this.skterkirim = true;
              this.header = this.response.nosurat;
              this.visible = true;
            } else {
              this.success = false;
            }
            this.getDataAnak();
            this.sedangkirimsuratkwitansi = false;
            this.loading = false;
            this.$store.commit('loading', this.loading);
          }
      );
    },
    kirimkwitansi(tipe){
      this.loading = true;
      this.$store.commit('loading', this.loading);
      let data = {
        'idanak': this.data.idanak,
        'invid': this.data.invid,
        'formulir': this.data.no_formulir,
        'jenis': 'kwitansi',
        'tipe': tipe,
        'email': this.emailtest,
        'emailortu': this.data.email,
        'attachment': this.fileattachment,
        'biaya': this.biaya
      };
      this.sedangkirimsuratkwitansi = true;
      this.content = "";
      let path = '/dashboard/kirimkwitansi';
      DashboardServices.postData(data, path).then(
          (response) => {
            this.response = response.data;
            this.message = response.data.message;
            this.messagetrx = this.message;
            if (response.status === 200) {
              this.successtrx = true;
              this.skterkirim = true;
            } else {
              this.successtrx = false;
            }
            this.sedangkirimsuratkwitansi = false;
            this.loading = false;
            this.logsuratkwitansi();
            this.$store.commit('loading', this.loading);
          }
      );
    },
    updatepelunasan(){
      this.loading = true;
      this.$store.commit('loading', this.loading);
      let data = {
        'idanak': this.data.idanak,
        'invid': this.data.invid,
        'jenis': 'suratpelunasan',
        'pelunasan':this.pelunasan,
        'attachment': this.fileattachment,
        'biaya': this.biaya
      };
      this.sedangupdatepelunasan = true;
      this.content = "";
      let path = '/dashboard/ubahStatusPelunasan';
      DashboardServices.postData(data, path).then(
          (response) => {
            this.response = response.data;
            this.message = response.data.message;
            if (response.data.status === 200) {
              this.success = true;
              this.getDataAnak();
            } else {
              this.success = false;
            }
            this.getDataAnak();
            this.sedangupdatepelunasan = false;
            this.loading = false;
            this.$store.commit('loading', this.loading);
          }
      );
    },
    simpanbiayapelunasan(){
      this.loading = true;
      this.$store.commit('loading', this.loading);
      let data = {
        'idanak': this.data.idanak,
        'invid': this.data.invid,
        'jenis': 'suratpelunasan',
        'diskon':this.diskon,
        'nosurat':this.nomorsuratpelunasan,
        'attachment': this.fileattachment,
        'biaya': this.biaya
      };
      this.sedangsimpansuratpelunasan = true;
      this.content = "";
      let path = '/dashboard/simpanbiayapelunasan';
      DashboardServices.postData(data, path).then(
          (response) => {
            this.response = response.data;
            this.message = response.data.message;
            if (response.data.status === 200) {
              this.success = true;
              this.content = atob(this.response.data);
              this.skterkirim = true;
              this.header = this.response.nosurat;
              this.visible = true;
            } else {
              this.success = false;
            }
            this.getDataAnak();
            this.sedangsimpansuratpelunasan = false;
            this.loading = false;
            this.$store.commit('loading', this.loading);
          }
      );
    },
    lihatsuratpelunasan(){
      this.loading = true;
      this.$store.commit('loading', this.loading);
      let data = {
        'idanak': this.data.idanak,
        'invid': this.data.invid,
        'jenis': 'suratpelunasan',
        'diskon':this.diskon,
        'nosurat':this.nomorsuratpelunasan,
        'attachment': this.fileattachment,
        'biaya': this.biaya
      };
      this.sedangkirimsuratpelunasan = true;
      this.content = "";
      let path = '/dashboard/lihatsuratpelunasan';
      DashboardServices.postData(data, path).then(
          (response) => {
            this.response = response.data;
            this.message = response.data.message;
            if (response.data.status === 200) {
              this.success = true;
              this.content = atob(this.response.data);
              this.skterkirim = true;
              this.header = this.response.nosurat;
              this.visible = true;
            } else {
              this.success = false;
            }
            this.getDataAnak();
            this.sedangkirimsuratpelunasan = false;
            this.loading = false;
            this.$store.commit('loading', this.loading);
            this.logsurat();
          }
      );
    },
    kirimsuratpelunasan(tipe){
      this.loading = true;
      this.$store.commit('loading', this.loading);
      let data = {
        'idanak': this.data.idanak,
        'invid': this.data.invid,
        'formulir': this.data.no_formulir,
        'jenis': 'suratpelunasan',
        'tipe': tipe,
        'email': this.emailtest,
        'emailortu': this.data.email,
        'attachment': this.fileattachment,
        'biaya': this.biaya
      };
      this.sedangkirimsuratpelunasan = true;
      this.content = "";
      let path = '/dashboard/kirimsuratpelunasanditerima';
      DashboardServices.postData(data, path).then(
          (response) => {
            this.response = response.data;
            this.message = response.data.message;
            this.messagetrx = this.message;
            if (response.status === 200) {
              this.successtrx = true;
              this.skterkirim = true;
            } else {
              this.successtrx = false;
            }
            this.sedangkirimsuratpelunasan = false;
            this.loading = false;
            this.$store.commit('loading', this.loading);
            this.logsurat();
          }
      );
    },
    getDataAnak(){
      this.loading = true;
      this.$store.commit('loading',this.loading);
      let data = {
        idanak:this.data.invid,
      };
      this.loadingdiskon = true;
      let path = '/dashboard/getDataAnak';
      this.sedangkirimsuratpelunasan = true;
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            if(response.data.status===200){
              this.dataanak = this.response;
              this.diskon = response.data.data.diskon;
              this.biaya =  response.data.data.biaya;
              this.pelunasan = response.data.data.pelunasan;
              this.nomorsuratpelunasan = response.data.data.nomor_dokumen;
              this.nomorsuratkwitansi = response.data.data.no_kwitansi;
            }
            this.loadingdiskon = false;
            this.sedangkirimsuratpelunasan = false;
          }
      );
    },
    getDataBiaya(){
      this.loading = true;
      this.$store.commit('loading',this.loading);
      let data = {
        paramname:this.data.invid,
        biaya:'spp'
      };
      this.loadingdiskon = true;
      let path = '/dashboard/getInfoBiayaSekolah';
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            this.message = response.data.message;
            if(response.data.status===200){
              this.databiaya = this.response.data;
            }
            this.loadingdiskon = false;
          }
      );
    },
    getDataInfoDiskon(){
      this.loading = true;
      this.$store.commit('loading',this.loading);
      let data = {
        paramname:this.data.invid,
        diskon:'diskon'
      };
      this.loadingdiskon = true;
      let path = '/dashboard/getInfoDiskon';
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            this.message = response.data.message;
            if(response.data.status===200){
              this.datadiskon = this.response.data;
            }
            this.loadingdiskon = false;
          }
      );
    },
    getDataUploadedFile(){
      this.loading = true;
      this.$store.commit('loading',this.loading);
      let data = {
        paramname:this.data.invid,
        filecat:'suratsk'
      };
      let path = '/dashboard/getListFile';
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            this.message = response.data.message;
            if(response.data.status===200){
              this.successloadfile = true;
              this.filelist = this.response.data;
            }else {
              this.successloadfile = false;
            }
            this.loading = false;
            this.$store.commit('loading',this.loading);
          }
      );
    },
    datasurat() {
      this.attachmentada = false
      this.loading = true;
      this.$store.commit('loading', this.loading);
      let data = {
        'idanak': this.data.idanak,
        'invid': this.data.invid,
        'jenis': 'suratsklns'
      };
      this.sedangkirimsuratpelunasan = true;
      let path = '/dashboard/datasurat';
      DashboardServices.postData(data, path).then(
          (response) => {
            this.response = response.data;
            this.message = response.data.message;
            if (response.data.status === 200) {
              this.successtrx = true;
              this.dataSurat = this.response.data;
              if (this.dataSurat.attachmentid>0){
                this.attachmentada = true;
                this.linkdokumen = this.dataSurat.link;
              }
            } else {
              this.successtrx = false;
            }
            this.sedangkirimsuratpelunasan = false;
            this.loading = false;
            this.$store.commit('loading', this.loading);
          }
      );
    },
    datakwitansi() {
      this.attachmentada = false
      this.loading = true;
      this.$store.commit('loading', this.loading);
      let data = {
        'idanak': this.data.idanak,
        'invid': this.data.invid,
        'jenis': 'kwitansi'
      };
      this.sedangkirimsuratkwitansi = true;
      let path = '/dashboard/datakwitansi';
      DashboardServices.postData(data, path).then(
          (response) => {
            this.response = response.data;
            this.message = response.data.message;
            if (response.data.status === 200) {
              this.successtrx = true;
              this.dataKwitansi = this.response.data;
              if (this.dataKwitansi.attachmentid>0){
                this.attachmentada = true;
                this.linkdokumen = this.dataKwitansi.link;
              }
            } else {
              this.successtrx = false;
            }
            this.sedangkirimsuratkwitansi = false;
            this.loading = false;
            this.$store.commit('loading', this.loading);
          }
      );
    },
    logsurat() {
      this.attachmentada = false
      this.loading = true;
      this.$store.commit('loading', this.loading);
      let data = {
        'idanak': this.data.idanak,
        'invid': this.data.invid,
        'jenis': 'suratpelunasan'
      };
      this.sedangkirimsuratpelunasan = true;
      let path = '/dashboard/logsurat';
      DashboardServices.postData(data, path).then(
          (response) => {
            this.response = response.data;
            this.message = response.data.message;
            if (response.data.status === 200) {
              this.successtrx = true;
              this.dataLogSurat = this.response.data;
            } else {
              this.successtrx = false;
            }
            this.loading = false;
            this.$store.commit('loading', this.loading);
          }
      );
    },
    logsuratkwitansi() {
      this.attachmentada = false
      this.loading = true;
      this.$store.commit('loading', this.loading);
      let data = {
        'idanak': this.data.idanak,
        'invid': this.data.invid,
        'jenis': 'kwitansi'
      };
      this.sedangkirimsuratpelunasan = true;
      let path = '/dashboard/logsurat';
      DashboardServices.postData(data, path).then(
          (response) => {
            this.response = response.data;
            this.message = response.data.message;
            if (response.data.status === 200) {
              this.successtrx = true;
              this.dataLogKwitansi = this.response.data;
            } else {
              this.successtrx = false;
            }
            this.loading = false;
            this.$store.commit('loading', this.loading);
          }
      );
    }
  },
  watch: {
    'biaya.spp'() { this.hitungBiayaTotal() },
    'biaya.up'() { this.hitungBiayaTotal() },
    'biaya.diskon.diskonuptahunpertama'() { this.hitungBiayaTotal() },
    'biaya.diskon.diskonspppembayaran1tahun'() { this.hitungBiayaTotal() },
    'biaya.diskon.diskonspp'() { this.hitungBiayaTotal() },
    'biaya.uangkonfirmasi'() { this.hitungBiayaTotal() },
    'diskon.jenisdiskon'(val) {
      if (!val || !this.datadiskon?.[val]) {
        this.biaya.diskon.diskonspp = 0
        return
      }
      if(val==='harga'){
        this.biayatahunan = this.databiaya.reguler
      }

      this.biaya.diskon.diskonspp = this.datadiskon[val].value
    },
  }
  ,mounted() {
    let path = '/dashboard/uploadFile';
    this.urlupload = DashboardServices.generateUrl(path);
    path = '/download/datasurat';
    this.urldownload = DashboardServices.generateUrl(path);
    this.getDataInfoDiskon();
    this.getDataBiaya();
    this.datasurat();
    this.datakwitansi();
    this.getDataUploadedFile();
    this.getDataAnak();
    this.logsurat();
    this.logsuratkwitansi();
  }
}
</script>

<style scoped>

.bg-simulasi-kewajiban {
  background-color: rgb(226, 239, 217) !important;
}

.bg-simulasi-potongan {
  background-color: rgb(255, 229, 152) !important;
}

.bg-simulasi-total-dibayar {
  background-color: rgb(231, 230, 230) !important;
}

.bg-simulasi-tanda-konfirmasi {
  background-color: rgb(251, 228, 213) !important;
}

.bg-simulasi-jumlah-harus-dibayarkan {
  background-color: rgb(189, 214, 238) !important;
}

.space-tr {
  background: #E2EFD9;
  box-shadow: inset 0 10px 0 #fff;
}
</style>